import { useState, useRef } from "react";
import { post } from "../../utils/ApiRequest";
import { useDelayedApiRequest } from "../../utils/DelayedApiRequest";
import { MdErrorOutline } from "react-icons/md";
import { useDaumPostcodePopup } from 'react-daum-postcode';
import validator from 'validator';
import { PURPLE } from "../../utils/designUtils";

export default function CreateNotOrgUser() {
    const [userInput, setUserInput] = useState({
        isCompany: false,
        organizationName: "",
        bizRegNo: -1,
        isValidate: false,
        userEmail: "",
        password: "",
        userName: "",
        eipCertificated: false,
        address: "",
        addressDetail: ""
    });

    const { delayedGet, cancelPending } = useDelayedApiRequest(500);

    const organizationName = useRef(null);
    const password = useRef(null);
    const confirmPassword = useRef(null);
    const userNm = useRef(null);
    const userEmail = useRef(null);

    const [orgNmErr, setOrgNmErr] = useState("");
    const [confirmPasswordErr, setConfirmPasswordErr] = useState("");
    const [passwordErr, setPasswordErr] = useState("");
    const [userEmailErr, setUserEmailErr] = useState("");
    const [userNmErr, setUserNmErr] = useState("");
    const [duplicateUserWarning, setDuplicateUserWarning] = useState("");

    const [isUserNameDisabled, setIsUserNameDisabled] = useState(false);
    const [isPasswordDisabled, setIsPasswordDisabled] = useState(false);
    const [isConfirmPasswordDisabled, setIsConfirmPasswordDisabled] = useState(false);

    function handleInputChange(event) {
        const { name, value } = event.target;
        if (name === 'userEmail') {
            setUserInput(prev => ({ ...prev, [name]: value }));
            if (!value.trim()) {
                cancelPending('userEmailCheck');
                setDuplicateUserWarning(""); setUserEmailErr("");
                setIsUserNameDisabled(false); setIsPasswordDisabled(false); setIsConfirmPasswordDisabled(false);
                return;
            }
            delayedGet('/user/selectUserName?userEmail=' + encodeURIComponent(value), 'userEmailCheck', (response, error) => {
                if (error) { setDuplicateUserWarning(""); return; }
                if (validator.isEmail(value) === false) {
                    setUserEmailErr("유효하지 않은 이메일 형식입니다."); return;
                }
                response.text().then(data => {
                    if (data?.trim() !== '') {
                        setUserInput(prev => ({ ...prev, userName: data }));
                        setIsUserNameDisabled(true); setIsPasswordDisabled(true); setIsConfirmPasswordDisabled(true);
                        setDuplicateUserWarning("이미 등록된 사용자입니다."); setUserEmailErr("");
                    } else {
                        setIsUserNameDisabled(false); setIsPasswordDisabled(false); setIsConfirmPasswordDisabled(false);
                        setDuplicateUserWarning(""); setUserEmailErr("");
                    }
                });
            });
        } else {
            setUserInput(prev => ({ ...prev, [name]: value }));
        }
    }

    const validatePasswordMatch = () => {
        const pw = password.current?.value || '';
        const cpw = confirmPassword.current?.value || '';
        if (pw && cpw) {
            setConfirmPasswordErr(pw === cpw ? "" : "비밀번호가 일치하지 않습니다.");
        } else {
            setConfirmPasswordErr("");
        }
    };

    const handleConfirmPassword = () => { validatePasswordMatch(); };
    const handlePasswordChange = (event) => {
        handleInputChange(event);
        if (confirmPassword.current?.value) setTimeout(validatePasswordMatch, 0);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!organizationName.current.value) {
            setOrgNmErr("조직명을 입력해 주세요"); organizationName.current.focus(); return;
        } else { setOrgNmErr(""); }
        setUserInput(prev => ({ ...prev, isValidate: false }));
        if (!userInput.userEmail) {
            setUserEmailErr("이메일을 입력해 주세요"); userEmail.current.focus(); return;
        } else { setUserEmailErr(""); }
        if (!userInput.password && !isPasswordDisabled) {
            setPasswordErr("사용하실 비밀번호를 입력해 주세요"); password.current.focus(); return;
        } else {
            setPasswordErr("");
            if (userInput.password !== confirmPassword.current.value && !isConfirmPasswordDisabled) {
                setConfirmPasswordErr("비밀번호가 일치하지 않습니다."); confirmPassword.current.focus(); return;
            } else { setConfirmPasswordErr(""); }
        }
        if (!userInput.userName) {
            setUserNmErr("이름을 입력해 주세요"); userNm.current.focus(); return;
        } else { setUserNmErr(""); }
        try {
            const response = await post('/user/createUserAndOrg', userInput);
            if (response.ok) {
                const result = await response.text();
                alert(result);
                window.location.href = "/";
            } else {
                alert('요청 처리 중 오류가 발생했습니다.');
            }
        } catch (error) {
            alert(`에러 발생: ${error.message}`);
        }
    };

    const popupOpen = useDaumPostcodePopup();
    const handleSearchAddress = () => { popupOpen({ onComplete: handleComplete }); };
    const handleComplete = (data) => {
        let fullAddress = data.address;
        let extraAddress = '';
        if (data.addressType === 'R') {
            if (data.bname !== '') extraAddress += data.bname;
            if (data.buildingName !== '') extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
            if (extraAddress !== '') fullAddress += ` (${extraAddress})`;
        }
        setUserInput(prev => ({ ...prev, address: fullAddress }));
    };

    const inputS = {
        width: '100%', height: 42, borderRadius: 10, border: '1.5px solid #e5e0f7',
        background: '#faf9fe', padding: '0 14px', fontSize: 14, color: '#1f1d2e',
        outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box',
        maxWidth: 'none', margin: 0, boxShadow: 'none',
    };

    const labelS = { display: 'block', fontSize: 13.5, fontWeight: 600, color: '#3a3849', marginBottom: 6 };
    const fieldS = { marginBottom: 18 };
    const errS = { display: 'flex', alignItems: 'center', gap: 6, color: '#ef4444', fontSize: 12.5, marginTop: 5 };
    const warnS = { color: '#d97706', fontSize: 12.5, marginTop: 5 };

    const secondaryBtn = {
        height: 42, padding: '0 16px', borderRadius: 10,
        border: `1.5px solid ${PURPLE}`, background: 'white',
        color: PURPLE, fontSize: 13.5, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
        whiteSpace: 'nowrap', flexShrink: 0,
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#f5f4fa', padding: '32px 16px' }}>
            <div style={{
                background: '#fff', borderRadius: 16,
                boxShadow: '0 4px 24px rgba(124,107,217,0.10)', border: '1px solid rgba(124,107,217,0.12)',
                padding: '40px', width: '100%', maxWidth: 520,
            }}>
                <h2 style={{ textAlign: 'center', fontWeight: 700, marginBottom: 28, color: '#1f1d2e', fontSize: 20, marginTop: 0 }}>
                    조직 (비사업자) 등록
                </h2>

                <form onSubmit={handleSubmit} style={{ maxWidth: 'none', margin: 0, padding: 0, border: 'none', borderRadius: 0, background: 'none' }}>

                    <div style={fieldS}>
                        <label style={labelS}>조직명</label>
                        <input name="organizationName" type="text" ref={organizationName}
                            onChange={handleInputChange} style={inputS}
                            onFocus={e => e.target.style.borderColor = PURPLE}
                            onBlur={e => e.target.style.borderColor = '#e5e0f7'}/>
                        {orgNmErr && <div style={errS}><MdErrorOutline size={16}/>{orgNmErr}</div>}
                    </div>

                    <div style={fieldS}>
                        <label style={labelS}>조직 주소</label>
                        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                            <input id="address" name="address" type="text"
                                value={userInput.address} readOnly
                                style={{ ...inputS, flex: 1, background: '#f5f4fa', cursor: 'default' }}/>
                            <button type="button" onClick={handleSearchAddress} style={secondaryBtn}>주소 검색</button>
                        </div>
                        <input id="addressDetail" name="addressDetail" type="text"
                            placeholder="상세 주소를 입력해 주세요" value={userInput.addressDetail}
                            onChange={handleInputChange} style={inputS}
                            onFocus={e => e.target.style.borderColor = PURPLE}
                            onBlur={e => e.target.style.borderColor = '#e5e0f7'}/>
                    </div>

                    <div style={{ borderTop: '1px solid #f0eff5', margin: '8px 0 18px' }}/>

                    <div style={fieldS}>
                        <label style={labelS}>조직 관리자 이메일</label>
                        <input name="userEmail" type="text" ref={userEmail} onChange={handleInputChange} style={inputS}
                            onFocus={e => e.target.style.borderColor = PURPLE}
                            onBlur={e => e.target.style.borderColor = '#e5e0f7'}/>
                        {userEmailErr && <div style={errS}><MdErrorOutline size={16}/>{userEmailErr}</div>}
                        {duplicateUserWarning && <div style={warnS}>{duplicateUserWarning}</div>}
                    </div>

                    <div style={fieldS}>
                        <label style={labelS}>비밀번호</label>
                        <input name="password" type="password" ref={password}
                            disabled={isPasswordDisabled} onChange={handlePasswordChange}
                            style={{ ...inputS, background: isPasswordDisabled ? '#f5f4fa' : '#faf9fe', cursor: isPasswordDisabled ? 'not-allowed' : 'text' }}
                            onFocus={e => { if (!isPasswordDisabled) e.target.style.borderColor = PURPLE; }}
                            onBlur={e => e.target.style.borderColor = '#e5e0f7'}/>
                        {passwordErr && <div style={errS}><MdErrorOutline size={16}/>{passwordErr}</div>}
                    </div>

                    <div style={fieldS}>
                        <label style={labelS}>비밀번호 확인</label>
                        <input name="confirmPassword" type="password" ref={confirmPassword}
                            disabled={isConfirmPasswordDisabled} onChange={handleConfirmPassword}
                            style={{ ...inputS, background: isConfirmPasswordDisabled ? '#f5f4fa' : '#faf9fe', cursor: isConfirmPasswordDisabled ? 'not-allowed' : 'text' }}
                            onFocus={e => { if (!isConfirmPasswordDisabled) e.target.style.borderColor = PURPLE; }}
                            onBlur={e => e.target.style.borderColor = '#e5e0f7'}/>
                        {confirmPasswordErr && <div style={errS}><MdErrorOutline size={16}/>{confirmPasswordErr}</div>}
                    </div>

                    <div style={fieldS}>
                        <label style={labelS}>조직 관리자 성명</label>
                        <input name="userName" type="text" ref={userNm}
                            value={userInput.userName} disabled={isUserNameDisabled} onChange={handleInputChange}
                            style={{ ...inputS, background: isUserNameDisabled ? '#f5f4fa' : '#faf9fe', cursor: isUserNameDisabled ? 'not-allowed' : 'text' }}
                            onFocus={e => { if (!isUserNameDisabled) e.target.style.borderColor = PURPLE; }}
                            onBlur={e => e.target.style.borderColor = '#e5e0f7'}/>
                        {userNmErr && <div style={errS}><MdErrorOutline size={16}/>{userNmErr}</div>}
                    </div>

                    <button type="submit" style={{
                        width: '100%', height: 46, borderRadius: 12, border: 'none',
                        background: `linear-gradient(135deg, ${PURPLE}, #9b8de8)`,
                        color: 'white', fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
                    }}>확인</button>

                </form>
            </div>
        </div>
    );
}
